function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  opacity: .89
}, React.createElement("path", {
  fill: "#183150",
  fillOpacity: .6,
  d: "M16.911 14a8 8 0 0 0-3.91-3.38 4 4 0 1 0-6 0A8 8 0 0 0 3.091 14a7.92 7.92 0 0 1-1.09-4 8 8 0 1 1 16 0 7.92 7.92 0 0 1-1.09 4zm-8.91-6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm2 10a8 8 0 0 1-5.55-2.25 6 6 0 0 1 11.1 0 8 8 0 0 1-5.55 2.25zm0-18a10 10 0 0 0-7.35 16.76 10 10 0 0 0 14.7 0A10 10 0 0 0 10.001 0z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/user.4e61ae55.svg";
export { SvgComponent as ReactComponent };